module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-260.9b88c9ab.svg";